<!--
 * @Author: your name
 * @Date: 2021-03-10 15:35:09
 * @LastEditTime: 2021-08-17 14:46:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\App.vue
-->
<template>
  <div id="app">
    <a-locale-provider :locale="locale">
      <!-- <router-view v-if="isRouterAlive"></router-view> -->
      <keep-alive include='totalProductPool'>
        <router-view />
      </keep-alive>

      <!-- <template  v-if='!$route.meta.keepAlive'>
       <router-view ></router-view>
    </template>
     <template v-else>
      <keep-alive  >
          <router-view></router-view>
      </keep-alive>
    </template>
      -->

    </a-locale-provider>

    <div v-if="flang">
      <Im class="bounced_" @close="flang = false"></Im>
    </div>

    <div class="slider_class " :class="showIm ? '' : 'hide_slider'">
      <div @click="showAndHide" class="operationBtn_">
      <a-icon type="left" v-if="!showIm" />
      <a-icon type="right" v-else />
      
      </div>
      <div class="jumpBox" @click="jump_" v-if="jump && $route.path != '/mbsend-contract'">
        <img src="./assets/icon/srm.jpg" alt="">
      </div>
      <div class="jumpBox" @click="service" v-if="$route.path != '/mbsend-contract'">
        <img src="./assets/icon/im.jpg" alt="">
      </div>
      
    </div>
    <div id="backTop"  style="position:fixed;bottom:30px;right:30px;cursor:pointer;font-size: 30px;" @click="toTop">
      <!-- <a-tooltip>
      <template slot="title">
        返回顶部
      </template> -->
      <a-icon type="up" />
      <!-- </a-tooltip> -->
    </div>
    
    <!-- <div class="aaa" @click="aaaa">

    </div>
    <div v-if="aaa">
      <Ch class="bounced"></Ch>
    </div> -->

    <!-- <div class="tip" v-if="unreadCount > 0">{{unreadCount}}</div> -->

  </div>
</template>
<script>
const global = require('../../static/global')
import { afterLogin } from '../Master/utils/commonLogin'

import {
  thequery,
  changeSystem,
  orgCode,
  currentUser,
} from './api/andPackage.js'
import Cookies from 'js-cookie'
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import Im from "./views/Im/Im"
import { initSettingBycurrUser , queryMenusByToken } from './api/common'
import { queryByUser } from './api/im.js'
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,

    }
  },
  data() {
    return {
      unreadCount: 0,//未读消息数
      friends: [],  //消息列表
      global,
      locale: zhCN,
      flang: false,
      jump: false,
      query: {
        // token: '',
        systemType: 2
      },
      from: {
        buttonStatus: true,
        hasSystem: true,
        systemType: 1
      },
      isRouterAlive: true,
      showIm: false,
      list: [],
    };

  },
  components: {
    Im,
  },
  watch: {
    flang() {
      this.initRecentContactList()
    }
  },
  created() {
    this.getUserInfoVuex()
    localStorage.setItem('imAccount', "")
    localStorage.setItem('userSig', "")
    var that = this
    // console.log(Cookies.get().initStore, '================')
    // if (Cookies.get().initStore == 'true') {
    //   // that.queryByUser()
    //   setTimeout(function () {
    //     that.queryByUser()
    //   }, 500)
    //   that.initRecentContactList()
    // }
    var token = Cookies.get('app.token_TAS', { domain: this.global.cookiePath })
    if (token) {
      localStorage.setItem('identifying', token)
    }

    that.$tim.on(that.$TIMS.EVENT.MESSAGE_RECEIVED, (event) => {
      that.initRecentContactList()
    })
    setTimeout(() => {
      
      if (this.$route.query.isEntry || !token ) {
        return
      }
      // this.showIm = true
      this.thequerys()
      this.$store.dispatch('getIndex')
      var logindata_TAS = Cookies.get().logindata_TAS ? JSON.parse(Cookies.get().logindata_TAS) : {}
      if (Cookies.get().initStore == true || logindata_TAS.initStore == true) {
        // that.queryByUser()
        setTimeout(function () {
          that.queryByUser()
        }, 500)
        that.initRecentContactList()
        this.$store.dispatch('querySpecialOrderSetting') //订单结算方式
      }


    }, 3000)
  },
  mounted() {
    localStorage.setItem('systemType',2)
    document.getElementById('PageTitleIndex').innerText = '旅游人自己的网店_一人一店，千人千面'
    var that = this
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('tagsList', "[]")
      for (let key in localStorage) {
        if (key.indexOf('cache') > -1) {
          localStorage.setItem(key, '')
        }
      }
    });
    window.addEventListener('storage', function (e) {
      if (e.key && e.key == 'identifying' && e.newValue && (e.newValue != e.oldValue)) {
        window.history.go(0)
      }
    })

  },
  methods: {
    toTop(){
      document.querySelector('.main-content').scrollTop = 0
    },
    getUserInfoVuex(){
      // queryMenusByToken({systemType:2}).then((res) => {
      //     if (res.code == 200) {             
      //       var userStatus =   Boolean(res.data)==false || (res.data&& res.data[0]&& res.data[0].status!=4)
      //       this.$store.commit('setUserData',res.data)
      //       this.$store.commit('setUserStatus',userStatus)     
      //     }
      //   });
        this.$store.dispatch("storeListFun");
    },
    showAndHide() {
      this.showIm = !this.showIm
    },
    // im获取未读消息数
    initRecentContactList() {
      var that = this
      // console.log(this.$tim, 'time22')
      let promise2 = this.$tim.login({
        userID: localStorage.getItem('imAccount'),
        userSig: localStorage.getItem('userSig'),
      });
      promise2.then(function (imResponse) {
        // console.log(imResponse, '登陆成功')
      }).catch(function (imError) {
        // util.sLoadingHide()
        // wx.showToast({
        //   title: 'login error' + imError,
        //   icon: 'none',
        //   duration: 3000
        // })
      })
      let promise = that.$tim.getConversationList();
      promise.then(function (imResponse) {
        // console.log(imResponse, '获取会话列表接口res')
        const conversationList = imResponse.data.conversationList; // 会话列表，用该列表覆盖原有的会话列表
        console.log(conversationList, '====获取会话列表接口666666666666=======')
        // that.friends = conversationList
        var aa = 0
        conversationList.forEach(item => {
          aa += item.unreadCount
        })
        that.unreadCount = aa
      }).catch(function (imError) {
        console.warn('getConversationList error:', imError); // 获取会话列表失败的相关信息
      });
    },

    queryByUser() {
      queryByUser().then(res => {
        console.log(res, '7777777777777777777777777777777')
        localStorage.setItem("imAccount", res.data.imAccount);
        localStorage.setItem("userSig", res.data.userSig);
        localStorage.setItem("accountType", res.data.accountType);
      })
    },
    service() {
      // console.log('pppppppppp')
      this.flang = !this.flang
      // console.log(this.flang)
    },
    // handleMessage(event) {
    //   // 根据上面制定的结构来解析 iframe 内部发回来的数据
    //   console.log('222222222222222')
    //   const data = event.data
    //   switch (data.cmd) {
    //     case 'ready-for-receiving':
    //       // 业务逻辑
    //       break
    //   }
    // },
    thequerys() {
      this.query.token = Cookies.get().token
      thequery(this.query).then(res => {
        if (res.code == 200) {
          console.log(res.data, '----------------------')
          this.from = res.data
          if (res.data.buttonStatus) {
            this.jump = true
          } else {
            this.jump = false
          }
        }
      })
    },
    // 跳转系统点击事件
    jump_() {
      // if (!this.from.buttonStatus) {
      //   return
      // }
      this.query.systemType = this.from.systemType
      changeSystem({ systemType: 1 }).then(res => {
        if (res.code == 200) {
          this.$message.success("系统切换成功,正在跳转请稍后")
          afterLogin.call(this, res, 1);

          // Cookies.set('app.token', res.data.token, { domain: global.cookiePath })
          // Cookies.set('logindata', res.data, { domain: global.cookiePath })
          // window.location.href = global.srmPath
        } else {
          this.$message.error('系统切换异常,请联系管理员')
        }
      })
    },
    reload() {
      window.location.reload()
      return
      var path = this.$route.fullPath
      //切换页面
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
        this.$router.push(path ? path : '')
      })
    }
  },
};

</script>

<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  height: 100%;
  display: flex;
}

.home .content {
  overflow-x: hidden;
}

.service img {
  width: 80px;
  height: 80px;
  border-radius: 40px;
  position: absolute;
  bottom: 2%;
  right: 1%;
  z-index: 999;
}

/* .bg{
  width: 100%;
  height: 100%;
  position: absolute;
  background: #b4b4b4ce
} */
.bounced_ {
  width: 1000px;
  // height: 70%;
  height: 654px;
  // border: 1px solid rgb(163, 163, 163);
  // background: rgb(160, 160, 160);
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
  border-radius: 20px;
  z-index: 99
}

.bounced {
  width: 100%;
  /* height: 70%; */
  /* border: 1px solid rgb(240, 17, 17); */
  position: absolute;
  border-radius: 10px;
  top: 8%;
  left: 45%;
  z-index: 99
}

.jump img {
  width: 86px;
  height: 86px;
  border-radius: 43px;
  position: absolute;
  bottom: 1.6%;
  right: 5.5%;
  z-index: 1001;
  /* background: #70e9b7 */
}

.bgColor {
  background: #c7c7c7d7
}

.tip {
  position: absolute;
  z-index: 1000;
  /* top: -3px;
        left: 40px; */
  bottom: 82px;
  right: 30px;
  height: 22px;
  min-width: 22px;
  font-size: 12px;
  color: #fffffe;
  line-height: 22px;
  text-align: center;
  background: #e24444;
  border-radius: 16px;
}

.aaa {
  width: 50px;
  height: 50px;
  background: rosybrown;
  position: absolute;
  bottom: 110px;
  right: 30px;
}

.tipRed {
  margin: 10px 0;
  color: #ff5555;
  font-size: 12px;
  display: block;
}

.redInfo {
  margin: 10px 0;
  color: #ff5555;
  font-size: 12px;
  display: block;
}

.slider_class {
  position: fixed;
  right: 0;
  bottom: 20px;
  width: auto;
  height: 100px;
  background: #05a2e5;
  
  border-radius: 10px 0 0 10px;
  // transition: right 0.5s;
  padding-left: 25px;
  text-align: right;
  overflow: hidden;

}

.operationBtn_ {
  position: absolute;
  height: 100%;
  width: 20px;
  background: rgba(255, 255, 255, 0.2);
  line-height: 100px;
  text-align: center;
  font-size: 20px;
  color: white;
  left: 0;
  top: 0;
  cursor: pointer;
}

.hide_slider {
  right: -5px;
  width: 0
}

.jumpBox {
  display: inline-block;
  // margin-top: 20rpx;
  position: relative;
  top: 8px;
  margin-right: 5px;
}

.jumpBox img {
  width: 86px;
  height: 86px;
  border-radius: 43px;
  z-index: 1001;
  border: 1px solid white;
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/TASMini/App.vue